module.exports = __webpack_public_path__ + "img/icon_yield.953ca906.svg";